import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_DIESEL,
  GET_DT_DIESEL_COLUMN,
  GET_DT_FUEL,
  GET_DT_FUEL_COLUMN,
  SAVE_DT_DIESEL,
  SAVE_DT_DIESEL_COLUMN,
  SAVE_DT_FUEL,
  SAVE_DT_FUEL_COLUMN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function DieselFuel(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumnDiesel, setShowManageColumnDiesel] = useState(false);
  const [columnDataListDiesel, setColumnDataListDiesel] = useState([]);
  const [columnManageListDiesel, setColumnManageListDiesel] = useState([]);
  const [showManageColumnFuel, setShowManageColumnFuel] = useState(false);
  const [columnDataListFuel, setColumnDataListFuel] = useState([]);
  const [columnManageListFuel, setColumnManageListFuel] = useState([]);
  const [dataList, setDataList] = useState({ diesel: [], fuel: [] });
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [modelDeviceListKeyin, setModelDeviceListKeyin] = useState([]);
  const [dateSelect, setDateSelect] = useState(
    moment().add("days", -1).toDate()
  );
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "20px",
      },
      formatter: CountIndexRow,
    },
  ]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = (tableId, headerId) => {
    let prevHeader = document.getElementById(headerId);
    prevHeader && prevHeader.remove();

    let thead = document
      .getElementById(`${tableId}`)
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.setAttribute("id", headerId);
    tr.innerHTML =
      '<th style="background-color:#2A3042"></th><th  colspan="' +
      columnDataListFuel.filter(obj => obj.FUELCOLUMN_SHOW == 1).length +
      '" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Fuel Oil (น้ำมันเตา)</th>' +
      '<th colspan="' +
      columnDataListDiesel.filter(obj => obj.DIESELCOLUMN_SHOW == 1).length +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Diesel (น้ำมันดีเซล)</th>';
    thead.prepend(tr);
  };
  const getColumnDiesel = () => post(GET_DT_DIESEL_COLUMN, {});
  const getColumnFuel = () => post(GET_DT_FUEL_COLUMN, {});
  const handleAddColumnDiesel = () => {
    setColumnManageListDiesel(prevent => [
      ...prevent,
      {
        ROW: columnManageListDiesel.length + 1,
        PID: "",
        DIESELCOLUMN_ORDER: columnManageListDiesel.length + 1,
        DIESELCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        DIESELCOLUMN_DESC: "",
        DIESELCOLUMN_TYPE: "",
        DIESELCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };
  const handleSaveColumnDiesel = async () => {
    function validateDuplicate() {
      let valueArr = columnManageListDiesel.map(function (item) {
        return item.DIESELCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageListDiesel.some(
          row => row.DIESELCOLUMN_NAME == "" || row.DIESELCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageListDiesel];
        let res = await post(SAVE_DT_DIESEL_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumnDiesel(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleAddColumnFuel = () => {
    setColumnManageListFuel(prevent => [
      ...prevent,
      {
        ROW: columnManageListFuel.length + 1,
        PID: "",
        FUELCOLUMN_ORDER: columnManageListFuel.length + 1,
        FUELCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        FUELCOLUMN_DESC: "",
        FUELCOLUMN_TYPE: "",
        FUELCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        show: { label: "Show", value: 1 },
        color: colorOption[0],
      },
    ]);
  };
  const handleSaveColumnFuel = async () => {
    function validateDuplicate() {
      let valueArr = columnManageListFuel.map(function (item) {
        return item.FUELCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageListFuel.some(
          row => row.FUELCOLUMN_NAME == "" || row.FUELCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageListFuel];
        let res = await post(SAVE_DT_FUEL_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumnFuel(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: new Date(date),
          DIESEL_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          DIESEL_DAY: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() ||
        (props.dateSelected.getMonth() < currentDate.getMonth() &&
          props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    let dataDieselList = addFieldToModelDeviceListDiesel(dayList);
    let dataDieselFuel = addFieldToModelDeviceListFuel(dayList);
    let dataList = [];
    dataDieselList.map(row => {
      dataDieselFuel.map(obj => {
        if (row.date == obj.date) {
          dataList.push({ ...row, ...obj });
        }
      });
    });
    // console.log(dataList.filter((m)=>{ console.log(moment(m.date).format('yyyy-MM-D') ,moment().format('yyyy-MM-D'))}))
    // dayList = addFieldToModelDeviceListFuel(dayList);

    setModelDeviceListKeyin([...dataList.filter((m) => moment(m.date).format('yyyy-MM-D') == moment(dateSelect).format('yyyy-MM-D'))])
    setModelDeviceList([...dataList]);
  };
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        {/* <button
          type="button"
          className="btn btn-secondary me-2"
          onClick={() => {}}
        >
          Refresh
        </button> */}
        {permission.eDFO && (
          <button
            type="button"
            className="btn btn-sm btn-success"
            onClick={() => {
              handleSaveDataByRow(row);
            }}
          >
            Save
          </button>
        )}
      </div>
    );
  };

  const formatNumber = (cellContent, row) => {
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };

  const renderColumn = () => {
    // console.log(columnDataListDiesel.map(obj =>console.log(obj.DIESELCOLUMN_NAME.replaceAll('.', '_')) ))
    setColumnRenderList([
      {
        dataField: "Dummy",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "rgb(126, 142, 218)",
          width: "20px",
          fontSize: "10px",
        },
        style: { width: "20px" },
        formatter: CountIndexRow,
      },
      ...columnDataListFuel
        .sort((a, b) =>
          a.FUELCOLUMN_ORDER > b.FUELCOLUMN_ORDER
            ? 1
            : b.FUELCOLUMN_ORDER > a.FUELCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj => obj.FUELCOLUMN_SHOW == true || obj.FUELCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel",
          text: obj.FUELCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          formatter: formatNumber,
          headerStyle: {
            backgroundColor: colorOption[obj.FUELCOLUMN_TYPE].label,
            width: "20px",
            fontSize: "10px",
          },
          editorStyle: () => {
            return { height: "25px" }
          },
          style: { width: "20px", cursor: "pointer" },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      ,
      ...columnDataListDiesel
        .sort((a, b) =>
          a.DIESELCOLUMN_ORDER > b.DIESELCOLUMN_ORDER
            ? 1
            : b.DIESELCOLUMN_ORDER > a.DIESELCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.DIESELCOLUMN_SHOW == true || obj.DIESELCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel",
          text: obj.DIESELCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          formatter: formatNumber,
          headerStyle: {
            backgroundColor: colorOption[obj.DIESELCOLUMN_TYPE].label,
            width: "20px",
            fontSize: "10px",
          },
          style: { width: "20px", cursor: "pointer" },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3)
              className += " pmis";
            return className;
          },
          editorStyle: () => {
            return { height: "25px" }
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      // {
      //   dataField: "Action",
      //   text: "Action",
      //   headerAlign: "center",
      //   editable: false,
      //   align: "center",
      //   headerStyle: {
      //     backgroundColor: "#556ee6",
      //     width: "10px",
      //     fontSize: "12px",
      //   },
      //   style: { width: "10px" },
      //   isDummyField: true,
      //   formatter: ButtonAction,
      // },
    ]);
  };
  const handleShowManageColumnDiesel = async () => {
    setColumnManageListDiesel([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumnDiesel(true);
      let column = await getColumnDiesel();
      // console.log(column);
      setColumnManageListDiesel(
        column.data.dtDieselColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.DIESELCOLUMN_TYPE],
          show:
            obj.DIESELCOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleShowManageColumnFuel = async () => {
    setColumnManageListFuel([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumnFuel(true);
      let column = await getColumnFuel();
      // console.log(column);
      setColumnManageListFuel(
        column.data.dtFuelColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.FUELCOLUMN_TYPE],
          show:
            obj.FUELCOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
                ? { label: "Scada", value: 1 }
                : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let dataDiesel = [];
      let dataFuel = [];
      //   console.log(row)
      modelDeviceListKeyin.map(row => {
        columnDataListDiesel.map(objColumn => {
          dataDiesel.push({
            ...row[
            `${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`
            ],
            DIESEL_DATA:
              row[objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel"],
          });
        });
        columnDataListFuel.map(objColumn => {
          dataFuel.push({
            ...row[
            `${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`
            ],
            FUEL_DATA:
              row[objColumn.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel"],
          });
        });


      })

      // console.log(dataDiesel,dataFuel);
      let [res1, res2] = await Promise.all([post(SAVE_DT_DIESEL, dataDiesel), post(SAVE_DT_FUEL, dataFuel)]);
      if (res1.resultCode == 200 && res2.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let dataDiesel = [];
      let dataFuel = [];
      //   console.log(row)
      columnDataListDiesel.map(objColumn => {
        dataDiesel.push({
          ...row[
          `${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`
          ],
          DIESEL_DATA:
            row[objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel"],
        });
      });
      columnDataListFuel.map(objColumn => {
        dataFuel.push({
          ...row[
          `${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`
          ],
          FUEL_DATA:
            row[objColumn.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel"],
        });
      });
      // console.log(dataDiesel,dataFuel);
      let [res1, res2] = await Promise.all([post(SAVE_DT_DIESEL, dataDiesel), post(SAVE_DT_FUEL, dataFuel)]);
      if (res1.resultCode == 200 && res2.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        // fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    let dataDiesel = [];
    let dataFuel = [];
    modelDeviceList.map(obj => {
      columnDataListDiesel.map(objColumn => {
        if (
          obj[`${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`].PID == ""
        ) {
          dataDiesel.push({
            ...obj[
            `${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`
            ],
            DIESEL_DATA:
              obj[objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel"],
          });
        }
      });

      columnDataListFuel.map(objColumn => {
        if (
          obj[`${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`].PID == ""
        ) {
          dataFuel.push({
            ...obj[`${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`],
            FUEL_DATA:
              obj[objColumn.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel"],
          });
        }
      });
    });

    // intialSave(dataDiesel, dataFuel);
  }, [modelDeviceList]);
  useEffect(() => {
    let dataDiesel = [];
    let dataFuel = [];
    modelDeviceListKeyin.map(obj => {
      columnDataListDiesel.map(objColumn => {
        if (
          obj[`${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`].PID == ""
        ) {
          dataDiesel.push({
            ...obj[
            `${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`
            ],
            DIESEL_DATA:
              obj[objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel"],
          });
        }
      });

      columnDataListFuel.map(objColumn => {
        if (
          obj[`${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`].PID == ""
        ) {
          dataFuel.push({
            ...obj[`${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`],
            FUEL_DATA:
              obj[objColumn.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel"],
          });
        }
      });
    });

    intialSave(dataDiesel, dataFuel);
  }, [modelDeviceListKeyin]);
  const intialSave = async (dataDiesel, dataFuel) => {
    // console.log(dataDiesel,dataFuel)
    if(permission.eDFO ){
      if (dataDiesel.length > 0 || dataFuel.length > 0) {
        dispatch(loadingAction.showLoading());
        try {
  
          let [res1, res2] = await Promise.all([post(SAVE_DT_DIESEL, dataDiesel), post(SAVE_DT_FUEL, dataFuel)]);
          if (res1.resultCode == 200 && res2.resultCode == 200) {
            // dispatch(messageAction.showMessage("Save success."));
            fetchData()
          } else {
            dispatch(messageAction.showMessage(res1.resultDescription));
          }
        } catch (error) {
          dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
      }
    }
   
  };

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let [columnDiesel, columnFuel] = await Promise.all([
        getColumnDiesel(),
        getColumnFuel(),
      ]);
      setColumnDataListDiesel(
        columnDiesel.data.dtDieselColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      setColumnDataListFuel(
        columnFuel.data.dtFuelColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let [dataDiesel, dataFuel] = await Promise.all([
        post(GET_DT_DIESEL, {
          DIESEL_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
        }),
        post(GET_DT_FUEL, {
          FUEL_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
        }),
      ]);
      setDataList({
        diesel: dataDiesel.data.dtDieselList,
        fuel: dataFuel.data.dtFuelList,
      });
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    //fixed header table
    // let tableId = "dieselfuel-tab-table";
    // let scrollY = 195;
    // function fixedTableHeader() {
    //   let headerTable = document.querySelector(`#${tableId} thead`);
    //   if (window.scrollY >= scrollY) {
    //     headerTable.classList.add("fixed-header");

    //     resizeTableHeader();
    //   } else {
    //     headerTable.classList.remove("fixed-header");
    //   }
    // }
    // function resizeTableHeader() {
    //   setTimeout(() => {
    //     let headerTable = document.querySelector(`#${tableId} thead`);
    //     let tr = document.querySelector(`#${tableId} tbody tr`);
    //     let th = headerTable.querySelector(".header-style");

    //     for (var i = 0; i < tr.childNodes.length; i++) {

    //       th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;

    //     }
    //   }, 1);
    // }
    // window.addEventListener("scroll", fixedTableHeader);
    // document
    //   .querySelector(`#vertical-menu-btn`)
    //   .addEventListener("click", resizeTableHeader);
    // return () => {
    //   window.removeEventListener("scroll", fixedTableHeader);
    //   document
    //     .querySelector(`#vertical-menu-btn`)
    //     ?.removeEventListener("click", resizeTableHeader);
    // };
    //fixed header table
  }, []);
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, [dateSelect]);
  useEffect(() => {
    renderColumn();
    addHeaderTable('dieselfuel-tab-table-keyin', 'dieselfuel-header-table-keyin');
    addHeaderTable('dieselfuel-tab-table', 'dieselfuel-header-table');
    if (columnDataListDiesel.length > 1 && columnDataListFuel.length > 1) {
      // generateRow();
    }
  }, [columnDataListDiesel, columnDataListFuel]);
  useEffect(() => {
    moment(props.dateSelected).isSame(new Date(), "month")
      ? setDateSelect(moment().add("days", -1).toDate())
      : setDateSelect(moment(props.dateSelected).endOf("month").toDate());
    // setDateSelect()

  }, [props.dateSelected]);
  const addFieldToModelDeviceListDiesel = rowList => {
    let dataModel = {
      PID: "",
      PID_DIESEL: "",
      DIESEL_DATE: "",
      DIESELCOLUMN_PID: "",
      DIESELCOLUMN_ORDER: 0,
      DIESELCOLUMN_NAME: "",
      DIESEL_DAY: 0,
      DIESEL_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let dataDiesel = dataList.diesel;

      let modelList = [];

      columnDataListDiesel.map(objColumn => {
        modelList = rowList.map(obj => {
          let valueDiesel = dataDiesel.find(
            value =>
              value.DIESELCOLUMN_PID == objColumn.PID &&
              value.DIESEL_DAY == obj.DIESEL_DAY
          );

          obj[objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_") + "_diesel"] =
            valueDiesel ? valueDiesel.DIESEL_DATA : 0;

          obj[
            `${objColumn.DIESELCOLUMN_NAME.replaceAll(".", "_")}__data_diesel`
          ] = {
            ...dataModel,
            ...valueDiesel,
            DIESEL_DATE: obj.DIESEL_DATE,
            DIESEL_DAY: obj.DIESEL_DAY,
            DIESELCOLUMN_PID: objColumn.PID,
            DIESELCOLUMN_ORDER: objColumn.DIESELCOLUMN_ORDER,
            DIESELCOLUMN_NAME: objColumn.DIESELCOLUMN_NAME,
          };
          return { ...obj };
        });
      });
      //   console.log(modelList)
      return modelList;
    }
  };
  const addFieldToModelDeviceListFuel = rowList => {
    let dataModel = {
      PID: "",
      PID_FUEL: "",
      FUEL_DATE: "",
      FUELCOLUMN_PID: "",
      FUELCOLUMN_ORDER: 0,
      FUELCOLUMN_NAME: "",
      FUEL_DAY: 0,
      FUEL_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let dataFuel = dataList.fuel;
      let modelList = [];
      // console.log(dataFuel)
      columnDataListFuel.map(objColumn => {
        modelList = rowList.map(obj => {
          let valueFuel = dataFuel.find(
            value =>
              value.FUELCOLUMN_PID == objColumn.PID &&
              value.FUEL_DAY == obj.DIESEL_DAY
          );

          obj[objColumn.FUELCOLUMN_NAME.replaceAll(".", "_") + "_fuel"] =
            valueFuel ? valueFuel.FUEL_DATA : 0;

          obj[`${objColumn.FUELCOLUMN_NAME.replaceAll(".", "_")}__data_fuel`] =
          {
            ...dataModel,
            ...valueFuel,
            FUEL_DATE: obj.DIESEL_DATE,
            FUEL_DAY: obj.DIESEL_DAY,
            FUELCOLUMN_PID: objColumn.PID,
            FUELCOLUMN_ORDER: objColumn.FUELCOLUMN_ORDER,
            FUELCOLUMN_NAME: objColumn.FUELCOLUMN_NAME,
          };
          return { ...obj };
        });
      });
      //   console.log(modelList)
      return modelList;
    }
  };
  const PickColorDiesel = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageListDiesel(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  DIESELCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const PickColorFuel = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageListFuel(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  FUELCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }
  const SelectShowFuel = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageListFuel(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  FUELCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectShowDiesel = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageListDiesel(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  DIESELCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManageDiesel = [
    {
      dataField: "DIESELCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor: "pointer",
      },
      type: "number",
    },

    {
      dataField: "DIESELCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       // {
    //       //   value: 2,
    //       //   label: "Flow Selection",
    //       // },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",

    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "DIESELCOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor: "pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColorDiesel,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShowDiesel,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  const columnManageFuel = [
    {
      dataField: "FUELCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor: "pointer",
      },
      type: "number",
    },

    {
      dataField: "FUELCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       // {
    //       //   value: 2,
    //       //   label: "Flow Selection",
    //       // },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",

    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "FUELCOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor: "pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColorFuel,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShowFuel,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">

          {permission.mMIM && (
            <div>
              <button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => handleShowManageColumnFuel()}
              >
                <i className="bx bx-columns"></i>&nbsp; Manage Column Fuel
              </button>
              <button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => handleShowManageColumnDiesel()}
              >
                <i className="bx bx-columns"></i>&nbsp; Manage Column Diesel
              </button>
            </div>
          )}

          {permission.eDFO && (
            <div>
              <button
                type="button"
                className="btn btn-success me-2"
                onClick={() => {
                  handleSaveData();
                }}
              >
                <i className="bx bx-save"></i>&nbsp; Save
              </button>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-between mt-2">

          <div style={{ width: "150px" }}>
            <Flatpickr
              className="form-control d-block custom-date-picker"
              placeholder="Select Date"
              options={{
                altInput: true,
                altFormat: "d/m/Y",
                // altFormat: "F Y",
                dateFormat: "d/m/Y",
                maxDate: moment(props.dateSelected).isSame(
                  new Date(),
                  "month"
                )
                  ? moment().add("days", -1).toDate()
                  : moment(props.dateSelected).endOf("month").toDate(),
                minDate: moment(props.dateSelected)
                  .startOf("month")
                  .toDate(),
              }}
              onChange={value => {
                setDateSelect(value[0]);
              }}
              value={dateSelect}
            />
            </div>
        </div>
        <div className="mt-2 table-responsive">
          <BootstrapTable
            id="dieselfuel-tab-table-keyin"
            keyField="date"
            data={modelDeviceListKeyin}
            columns={columnRenderList}
            rowStyle={rowStyle}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#dieselfuel-tab-table-keyin .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $(
                  "#dieselfuel-tab-table-keyin .form-control.editor.edit-text"
                ).keypress(function (e) {
                  if (e.keyCode == 13) {
                    $(this).trigger("enterKey");
                  }
                });
              },
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(oldValue,newValue, row, column)
              },
            })}
          />
        </div>
        <div className="mt-2 table-responsive">
          <BootstrapTable
            id="dieselfuel-tab-table"
            keyField="date"
            data={modelDeviceList}
            columns={columnRenderList}
            rowStyle={rowStyle}
            headerClasses="header-style"

          />
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumnDiesel} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Diesel</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumnDiesel(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-diesel-table"
            keyField="ROW"
            data={columnManageListDiesel}
            columns={columnManageDiesel}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManageDiesel}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataListDiesel);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumnDiesel()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumnDiesel()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumnDiesel(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
      <Modal size="xl" isOpen={showManageColumnFuel} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Fuel</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumnFuel(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-fuel-table"
            keyField="ROW"
            data={columnManageListFuel}
            columns={columnManageFuel}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManageFuel}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataListDiesel);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumnFuel()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumnFuel()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumnFuel(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManageDiesel = [
  {
    dataField: "DIESELCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
const defaultSortColumnManageFuel = [
  {
    dataField: "FUELCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default DieselFuel;

const CountIndexRow = (cell, row, rowIndex) => moment(row.date).format('D');

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

DieselFuel.propTypes = {
  dateSelected: PropTypes.any,
};
